import styled from 'styled-components';
import { IconButton } from '@chegg-ui/button';
import { Modal } from '@chegg-ui/modal';
import { breakpoints, colors, spacing, zindex } from '@chegg-ui/theme';
var IconSmMaxStyles = "\n  width: 1.25rem;\n  height: 1.25rem;\n  min-width: 1.25rem;\n  min-height: 1.25rem;\n";
export var ModalSC = styled(Modal).withConfig({
  componentId: "sc-1dj3tiz-0"
})(["z-index:", ";@media only screen and (min-width:", "){#mfa-dialog-container{width:760px;}}@media only screen and (min-width:", ") and (max-width:", "){#mfa-dialog-container{width:642px;}}@media only screen and (min-width:", ") and (max-width:", "){#mfa-dialog-container{width:450px;}}@media only screen and (max-width:", "){#mfa-dialog-container{width:312px;}#modalCloseIcon{", ";}}", ""], zindex.sledgehammer, breakpoints.xl.min, breakpoints.lg.min, breakpoints.lg.max, breakpoints.md.min, breakpoints.md.max, breakpoints.sm.max, IconSmMaxStyles, function (props) {
  if (props.byEmail) {
    return "#mfa-dialog-container > div {\n                padding: 0;\n            }";
  }
});
export var MfaDialogSC = styled.section.withConfig({
  componentId: "sc-1dj3tiz-1"
})(["display:flex;flex-direction:column;justify-content:center;align-items:center;"]);
export var GoBackLinkSC = styled(IconButton).withConfig({
  componentId: "sc-1dj3tiz-2"
})(["position:absolute;&,&:hover,&:active{box-shadow:none;border:0;background:", ";}color:", ";top:", ";left:", ";svg{width:", ";height:", ";}@media (max-width:", "){top:", ";left:", ";svg{", ";}}"], colors.transparent, colors.grey900, getBackCoords, getBackCoords, spacing.px24, spacing.px24, breakpoints.sm.max, getMinBackCoords, getMinBackCoords, IconSmMaxStyles);
function getBackCoords(props) {
  if (props.byEmail) {
    return spacing.px12;
  }
  return '-3.25rem';
}
function getMinBackCoords(props) {
  if (props.byEmail) {
    return spacing.px4;
  }
  return "-".concat(spacing.px32);
}